import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAdvertentieHuisgenoot = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FADCEB"
      d="M20 27.02c6.357 0 11.51-5.153 11.51-11.51S26.357 4 20 4 8.49 9.153 8.49 15.51 13.643 27.02 20 27.02"
    />
    <mask
      id="AdvertentieHuisgenoot_svg__a"
      width={24}
      height={24}
      x={8}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M20 27.02c6.357 0 11.51-5.153 11.51-11.51S26.357 4 20 4 8.49 9.153 8.49 15.51 13.643 27.02 20 27.02"
      />
    </mask>
    <g
      fill="#F29FC5"
      mask="url(#AdvertentieHuisgenoot_svg__a)"
    >
      <path
        fillRule="evenodd"
        d="M19.99 19.24c2.97 0 5.38 2.41 5.38 5.38v9.51H14.61v-9.51c0-2.97 2.41-5.38 5.38-5.38"
        clipRule="evenodd"
      />
      <path d="M20.01 19.24a5.38 5.38 0 1 0 0-10.76 5.38 5.38 0 0 0 0 10.76" />
    </g>
    <path
      stroke="#F29FC5"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M12 31h16M12 35h10"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAdvertentieHuisgenoot);

export default ForwardRef;
